import { COLORS } from "shared/consts";
import { toRem } from "shared/helpers";
import styled, { css } from "styled-components";

type SearchListInputWrapperProps = {
  $isDrawer?: boolean;
}
export const SearchListInputWrapper = styled.div<SearchListInputWrapperProps>`
  padding: ${props => !props.$isDrawer && `${toRem(8)} ${toRem(12)}` || `0 0 ${toRem(12)} 0`};
  border-bottom: ${toRem(1)} solid #000;
`

type SearchListBodyProps = {
  $isDrawer?: boolean;
}
export const SearchListBody = styled.div<SearchListBodyProps>`
scrollbar-width: thin;
overflow: hidden auto;
max-height: ${toRem(300)};
  ${props => !props.$isDrawer && css`
      max-height: calc(100dvh - ${toRem(355)});
  `}
`

export const SearchListSector = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${toRem(4)};
  padding: ${toRem(8)};
  &>span {
    font-size: ${toRem(12)};
    line-height: ${16 / 12};
    padding: ${toRem(8)} ${toRem(12)};
    color: ${COLORS.FG.MUTED};
  }

  &:not(:last-child) {
    border-bottom: ${toRem(1)} solid ${COLORS.BORDER.MUTED};
    padding-bottom: ${toRem(12)};
    margin-bottom: ${toRem(8)};
  }
`

type SearchListItemProps = {
  $isActive: boolean
}
export const SearchListItem = styled.div<SearchListItemProps>`
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: ${toRem(8)} ${toRem(12)};
  display: flex;
  align-items: center;
  gap: ${toRem(8)};
  color: ${props => props.$isActive ? COLORS.ACCENT.DEFAULT : COLORS.FG.DEFAULT};
  background-color: ${props => props.$isActive ? COLORS.ACCENT.CONTAINER_SOFT : 'transparent'};
  border-radius: ${toRem(8)};
  transition: background-color 0.3s ease 0s, color 0.3s ease 0s;

  img {
    width: ${toRem(16)};
    height: ${toRem(16)};
  }

  @media (any-hover: hover){
    &:hover{
      background-color: ${COLORS.ACCENT.CONTAINER_HOVER};
    }
  }

  svg {
    opacity: ${props => props.$isActive ? 1 : 0};
  }
`